// extracted by mini-css-extract-plugin
export var clauseRow = "_dx-6";
export var emptyState = "_dx-d";
export var filterContent = "_dx-a";
export var filterGroup = "_dx-1";
export var filterGroupContainer = "_dx-0";
export var nestedGroup = "_dx-2";
export var nestedGroupContent = "_dx-b";
export var nestedGroupDepth1 = "_dx-3";
export var nestedGroupDepth2 = "_dx-4";
export var nestedGroupDepth3 = "_dx-5";
export var nestedGroupEmpty = "_dx-c";
export var operatorAnd = "_dx-8";
export var operatorOr = "_dx-9";
export var operatorToggle = "_dx-7";
export var removeGroupButton = "_dx-e";